import React, {useContext} from 'react';
import IconBase from './IconBase';
import {BrandContext} from "../BrandContext";

const ScorcherIcon = props => {
    const brandConfig = useContext(BrandContext);
    return (
        <IconBase defaultTooltipTitle={brandConfig.scorcherName} useTag={'<use xlink:href="#scorcher-icon"/>'} viewBox={'0 0 128 128'} {...props}>
        </IconBase>
    )
}

export default ScorcherIcon;